import { Component } from '@angular/core';

@Component({
  selector: 'app-my-solution-homepage',
  template: `
    <div class="ms-page">
      <div><app-my-solutions></app-my-solutions></div>
    </div>
  `,
  styleUrls: ['./my-solution-homepage.component.scss'],
})
export class MySolutionHomepageComponent {}
